import { UserBaseInfo } from '@users/models/user-base-info';

export const DELETED_USER_BASE_INFO: UserBaseInfo  = {
    customerId: 0,
    fullName: 'Removed Account',
    profileImage: '/assets/images/unavailable-images/deleted-customer.png'
};